import React from "react";

const EllipseIcon = ({ color = "#EBE4FF", ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="293"
      height="260"
      viewBox="0 0 293 260"
      fill="none"
      {...rest}
    >
      <g filter="url(#filter0_f_8524_55073)">
        <ellipse cx="146.5" cy="128.5" rx="77.5" ry="73.5" fill={color} />
      </g>
      <defs>
        <filter
          id="filter0_f_8524_55073"
          x="-28.3"
          y="-42.3"
          width="349.6"
          height="341.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="48.65" result="effect1_foregroundBlur_8524_55073" />
        </filter>
      </defs>
    </svg>
  );
};

export default EllipseIcon;
